import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { FlowsHistoryRoutingModule } from './flows-history-routing.module';
import { ListFlowsHistoryComponent } from './pages/list-flows-history/list-flows-history.component';

@NgModule({
  declarations: [ListFlowsHistoryComponent],
  imports: [
    CommonModule,
    FlowsHistoryRoutingModule,
    FormsModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    CoreModule,
    PrimeNgModule,
    ComponentsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class FlowsHistoryModule {}
